import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '@app/components/button/button.module';
import { ContainerModule } from '@app/components/container/container.module';
import { MyLifeChangesComponent } from './myLifeChanges.component';
import { MyLifeChangesRoutingModule } from './myLifeChanges-routing.module';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { BlockLifeChangesModule } from '@app/components/blocks/block-lifeChanges/block-lifeChanges.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    ContainerModule,
    MyLifeChangesRoutingModule,
    PlIconModule,
    SharedModule,
    BlockLifeChangesModule,
    FormsModule,
  ],
  declarations: [MyLifeChangesComponent],
})
export class MyLifeChangesModule {}
